<template>
    <vs-popup classContent="popup-example" :title="translate('AddKey')" :active.sync="popUps.popupAddProvider">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('Name')" v-model="formParams.name" />
        </div>
      </div>
      <div class="vx-row mb-6" v-if="beneficiaries.length>0">
        <div class="vx-col w-full">
          <vs-select
              placeholder="Select beneficiary"
              autocomplete
              class="selectExample w-full"
              label="Beneficiaries"
              v-model="formParams.beneficiary"
              >
              <vs-select-item :key="index" :value="item.beneficiary" :text="item.beneficiary" v-for="(item,index) in beneficiaries" />
          </vs-select>
          </div>
      </div>            
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('Description')" v-model="formParams.description" />
        </div>
      </div>      
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('Price')" v-model="formParams.price" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('Comments')" v-model="formParams.comments" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="addProvider()" color="primary" type="filled">{{translate('Save')}}</vs-button>
        </div>
      </div>
    </vs-popup>
</template>
<script>
import axios from "@/axios.js"
export default {
    props:['closePopups','formParams','popUps','openAlert'],
    data() {
        return {
          beneficiaries: []
        }
    },
    watch: {
    'popUps.popupAddProvider'(val) {
      if(val===true && this.beneficiaries.length===0)
        this.getBeneficiaries();
      }
    },
    methods:{
      getBeneficiaries: function(){
        let that = this;
        this.$vs.loading();
        axios.get("https://crm.evblock.com/api/lists?beneficiaries")
        .then((response) => {
          that.$vs.loading.close();
          for(let i in response.data){
            const obj = JSON.parse(response.data[i].object);
            that.beneficiaries.push(obj);
          }
        })
      .catch(() => { that.$vs.loading.close(); that.openAlert('danger','Failed'); })
      },
      addProvider: function(){
        let that = this;
        this.$vs.loading();
        axios.post("https://crm.evblock.com/api/providers",this.formParams)
        .then(() => {
          that.$vs.loading.close();
          that.closePopups();
          that.openAlert('success','Success');
          that.componentKey++;
        })
      .catch(() => { that.$vs.loading.close(); that.openAlert('danger','Failed'); })
      },
      translate: function(key){
        return this.$t(key);
      },      
    }
}
</script>